<template>
    <div class="reward-item-container">
        <div class="reward-item">
            <div class="reward-item-title">
                <div class="item-title-icon"></div>
                <div :class="['item-center-title', language == 'ug' && 'item-center-title-ug']">
                    {{ title }}
                </div>
                <div class="item-title-icon"></div>
            </div>
            <div class="reward-item-bg">
                <div class="reward-item-content">
                    <slot name="content"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        language: {
            type: String,
            default: 'ug'
        }
    }
}
</script>

<style lang="scss" scoped>
.reward-item-container {
    border-radius: 12px;
    background-color: #fff;
    padding-top: 5px;
    margin-bottom: 24px;
    .reward-item {
        border-radius: 12px 12px;
        background: linear-gradient( 180deg, #83DAFF 10%, #96B4FF 35%);

        .reward-item-title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 14px 16px;

            .item-title-icon {
                display: flex;
                width: 48px;
                height: 8px;
                background: url("../../../assets/reward/reward-title-icon.png") no-repeat;
                background-size: contain;
            }

            .item-center-title {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 162px;
                height: 34px;
                text-align: center;
                font-weight: 500;
                font-size: 18px;
                background: #3BB1F6;
                border-radius: 17px;
                color: #FFFFFF;
            }

            .item-center-title-ug {
                width: 170px;
                height: 42px;
                font-size: 16px;
                border-radius: 57px;
                font-family: "UKIJCJK";
             }
        }

        .reward-item-bg {
            border-radius: 12px 12px;
            padding: 16px;
            background-color: #fff;
        }

        .reward-item-content {
            width: 100%;
            height: 100%;
            background: #E8F5FF;
            border-radius: 8px;
        }
    }
}
</style>